import { PixLimitsService } from './limits/limits.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SlickModule } from 'ngx-slick';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { MatRadioModule, MatSelectModule, MatDatepickerModule, MatSlideToggleModule, MatSliderModule, MatAutocompleteModule, MatIconModule, MatButtonModule } from '@angular/material';
import { PixService } from './pix.service';
import { PixOnboardingComponent } from './onboarding/onboarding.component';
import { PixHomeComponent } from './home/home.component';
import { PixFilterPeriodComponent } from './filter-period/filter-period.component';
import { PixKeysOnboardingComponent } from './keys/onboarding/onboarding.component';
import { PixKeysCreateComponent } from './keys/create/create.component';
import { PixKeysComponent } from './keys/list/list.component';
import { PixKeysCreateModalInfoComponent } from './keys/create/modal-info/modal-info.component';
import { AutenticationModule } from '../../autentication/autentication.module';
import { PixKeysCreateHeaderMenuComponent } from './keys/create/header-menu/header-menu.component';
import { PixKeysCreateAssignatureComponent } from './keys/create/assignature/assignature.component';
import { PixKeysService } from './keys/keys.service';
import { PixHomeMenuComponent } from './home/menu/menu.component';
import { PixExtractComponent } from './extract/extract.component';
import { PixKeysListAssignatureComponent } from './keys/list/assignature/assignature.component';
import { PixMyQrCodeComponent } from './my-qr-code/my-qr-code.component';
import { PixPaymentKeyComponent } from './payment-key/payment-key.component';
import { PixPaymentKeyFavoredListComponent } from './payment-key/favored-list/favored-list.component';
import { PixPaymentKeyFavoredCreateComponent } from './payment-key/favored-create/favored-create.component';
import { PixPaymentKeyAssignatureComponent } from './payment-key/assignature/assignature.component';
import { PixPaymentKeyService } from './payment-key/payment-key.service';
import { PixPaymentKeyMenuComponent } from './payment-key/favored-create/menu/menu.component';
import { PixModalPaymentKeyFavoredCreateSuccessComponent } from './payment-key/favored-create/modal-create-success/modal-create-success.component';
import { PixModalPaymentKeyFavoredCreateNotFoundComponent } from './payment-key/favored-create/modal-create-not-found/modal-create-not-found.component';
import { PixPaymentKeyFavoredCreateAgencyAccountComponent } from './payment-key/favored-create/agency-account/agency-account.component';
import { PixPaymentKeyFavoredCreateValueAndDateComponent } from './payment-key/favored-create/value-date/value-date.component';
import { PixPaymentKeyFavoredCreateResumeComponent } from './payment-key/favored-create/resume/resume.component';
import { PixPaymentKeyFavoredCreateResumeFinalComponent } from './payment-key/favored-create/resume-final/resume-final.component';
import { PixLimitsComponent } from './limits/limits.component';
import { PixAdjustComponent } from './limits/adjust/adjust.component';
import { PixUnderstandComponent } from './limits/understand/understand.component';
import { PixKeysListComponent } from './keys/list/keys/keys.component';
import { PixClaimsListComponent } from './keys/list/claims/claims.component';
import { PixExtractDetailsComponent } from './extract/details/details.component';
import { PixHelpComponent } from './help/help.component';
import { PixKeysCreateValidationCodeComponent } from './keys/create/validation-sms/validation-code.component';
import { PixKeysClaimService } from './keys/keys-claim.service';
import { PixReceivePaymentListChoiceComponent } from './receive-payment/list/choice-modal/choice-modal.component';
import { PixReceivePaymentListComponent } from './receive-payment/list/list.component';
import { PixReceivePaymentProfessionalComponent } from './receive-payment/professional/professional.component';
import { PixReceivePaymentQrCodeComponent } from './receive-payment/qr-code/qr-code-resume.component';
import { PixReceivePaymentResumeComponent } from './receive-payment/resume/resume.component';
import { PixReceivePaymentSimpleComponent } from './receive-payment/simple/simple.component';
import { PixRefundAssignatureComponent } from './refund/assignature/assignature.component';
import { PixRefundResumeFinalComponent } from './refund/resume-final/resume-final.component';
import { PixRefundValueComponent } from './refund/value/value.component';
import { QRCodeModule } from 'angularx-qrcode';
import { PixPaymentKeyFavoredCreateAssignatureComponent } from './payment-key/favored-create/assignature/assignature.component';
import { PixCopyAndPasteComponent } from './copy-and-paste/copy-and-paste.component';
import { PixKeysListAssignatureClaimComponent } from './keys/list/assignature-claim/assignature-claim.component';
import { PixRefundService } from './refund/refund.service';
import { PixQrCodeDynamicService } from './copy-and-paste/qr-code-dynamic/qr-code-dynamic.service';
import { PixQrCodeDynamicModalDateComponent } from './copy-and-paste/qr-code-dynamic/resume-final/modal-date/modal-date.component';
import { PixAdjustLimitsAssignatureComponent } from './limits/assignature/assignature.component';
import { PixModalReducedLimitComponent } from './limits/modal-reduced-limit/modal-reduced-limit.component';
import { PixQrCodeDynamicResumeFinalComponent } from './copy-and-paste/qr-code-dynamic/resume-final/resume-final.component';
import { PixPaymentKeyFavoredCreateDetailComponent } from './payment-key/favored-create/details/details.component';
import { PixReceiptComponent } from './receipt/receipt.component';
import { PixReceiptService } from './receipt/receipt.service';
import { PixQrCodeDynamicModalMsgComponent } from './copy-and-paste/qr-code-dynamic/resume-final/modal-msg/modal-msg.component';
import { PixQrCodeDynamicModalValueComponent } from './copy-and-paste/qr-code-dynamic/resume-final/modal-value/modal-value.component';
import { PixQrCodeDynamicAssignatureComponent } from './copy-and-paste/qr-code-dynamic/assignature/assignature.component';
import { PixWithdrawChangeComponent } from './withdraw-change/withdraw-change.component';
import { PixWithdrawChangeMenuComponent } from './withdraw-change/menu/menu.component';
import { PixWithdrawChangeFaqComponent } from './withdraw-change/faq/faq.component';
import { PixWithdrawChangeHelpComponent  } from './withdraw-change/faq/help/help.component';
import { PixWithdrawChangeValueDateComponent } from './withdraw-change/copy-and-paste/value-date/value-date.component';
import { PixWithdrawChangeResumeComponent } from './withdraw-change/copy-and-paste/resume/resume.component';
import { PixWithdrawChangeAssignatureComponent } from './withdraw-change/copy-and-paste/assignature/assignature.component';
import { WithdrawChangeGuard } from './withdraw-change/guard/withdraw-change.guard';
import { WithdrawChangeService } from './withdraw-change/service/withdraw-change.service';
import { ModalSucessComponent } from '../../shared/modal-sucess/modal-sucess.component';


@NgModule({
	imports: [
		CommonModule,
		CurrencyMaskModule,
		SharedModule,
		AutenticationModule,
		RouterModule,
		MatCardModule,
		MatTableModule,
		MatCheckboxModule,
		MatRadioModule,
		MatAutocompleteModule,
		MatIconModule,
		MatButtonModule,
		FormsModule,
		ReactiveFormsModule,
		SlickModule.forRoot(),
		NgxMaskModule.forRoot(),
		MatSelectModule,
		MatDatepickerModule,
		MatSlideToggleModule,
		MatSliderModule,
		QRCodeModule,
		NgxMaskModule
	],
	declarations: [
		PixOnboardingComponent,
		PixHomeComponent,
		PixHomeMenuComponent,
		PixFilterPeriodComponent,
		PixKeysOnboardingComponent,
		PixKeysCreateComponent,
		PixKeysComponent,
		PixKeysListComponent,
		PixKeysListAssignatureComponent,
		PixClaimsListComponent,
		PixKeysCreateModalInfoComponent,
		PixKeysCreateValidationCodeComponent,
		PixKeysCreateHeaderMenuComponent,
		PixKeysCreateAssignatureComponent,
		PixExtractComponent,
		PixMyQrCodeComponent,
		PixPaymentKeyComponent,
		PixPaymentKeyFavoredListComponent,
		PixPaymentKeyFavoredCreateComponent,
		PixPaymentKeyAssignatureComponent,
		PixPaymentKeyMenuComponent,
		PixModalPaymentKeyFavoredCreateSuccessComponent,
		PixModalPaymentKeyFavoredCreateNotFoundComponent,
		PixPaymentKeyFavoredCreateAgencyAccountComponent,
		PixPaymentKeyFavoredCreateValueAndDateComponent,
		PixPaymentKeyFavoredCreateResumeComponent,
		PixPaymentKeyFavoredCreateResumeFinalComponent,
		PixPaymentKeyFavoredCreateAssignatureComponent,
		PixReceivePaymentListComponent,
		PixReceivePaymentSimpleComponent,
		PixReceivePaymentQrCodeComponent,
		PixReceivePaymentListChoiceComponent,
		PixReceivePaymentProfessionalComponent,
		PixReceivePaymentResumeComponent,
		PixExtractDetailsComponent,
		PixRefundValueComponent,
		PixRefundAssignatureComponent,
		PixRefundResumeFinalComponent,
		PixHelpComponent,
		PixLimitsComponent,
		PixAdjustComponent,
		PixUnderstandComponent,
		PixModalReducedLimitComponent,
		PixCopyAndPasteComponent,
		PixKeysListAssignatureClaimComponent,
		PixPaymentKeyFavoredCreateDetailComponent,
		PixReceiptComponent,
		PixQrCodeDynamicResumeFinalComponent,
		PixQrCodeDynamicModalDateComponent,
		PixAdjustLimitsAssignatureComponent,
		PixQrCodeDynamicModalMsgComponent,
		PixQrCodeDynamicModalValueComponent,
		PixQrCodeDynamicAssignatureComponent,
		PixWithdrawChangeComponent,
		PixWithdrawChangeMenuComponent,
		PixWithdrawChangeFaqComponent,
		PixWithdrawChangeHelpComponent,
		PixWithdrawChangeValueDateComponent,
		PixWithdrawChangeResumeComponent,
		PixWithdrawChangeAssignatureComponent,
	],
	providers: [
		PixService,
		PixKeysService,
		PixPaymentKeyService,
		PixKeysClaimService,
		PixRefundService,
		PixReceiptService,
		PixQrCodeDynamicService,
		PixLimitsService,
		WithdrawChangeGuard,
		WithdrawChangeService
	],
	entryComponents: [
		PixKeysCreateModalInfoComponent,
		PixMyQrCodeComponent,
		PixModalPaymentKeyFavoredCreateSuccessComponent,
		PixModalPaymentKeyFavoredCreateNotFoundComponent,
		PixReceivePaymentListChoiceComponent,
		PixExtractDetailsComponent,
		PixHelpComponent,
		PixAdjustComponent,
		PixUnderstandComponent,
		PixPaymentKeyFavoredCreateDetailComponent,
		PixQrCodeDynamicModalDateComponent,
		PixModalReducedLimitComponent,
		PixQrCodeDynamicModalMsgComponent,
		PixQrCodeDynamicModalValueComponent,
		PixWithdrawChangeFaqComponent,
		ModalSucessComponent
	],
})
export class PixModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/pix.module.ts